import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {AccreditationEvidenceFile} from "../../models/accreditation-evidence-file";

@Component({
    selector: 'app-archive-evidence-file-warning',
    templateUrl: './archive-evidence-file-warning.component.html',
    styleUrls: ['./archive-evidence-file-warning.component.scss'],
    standalone: false
})
export class ArchiveEvidenceFileWarningComponent implements OnInit {

  evidenceFile: AccreditationEvidenceFile;
  constructor(public dialogRef: MatDialogRef<ArchiveEvidenceFileWarningComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.evidenceFile = this.data.evidenceFile;
  }

  cancel(){
    this.dialogRef.close(false);
  }
  archiveEvidenceAttachment() {
    this.dialogRef.close(true);
  }

}
